import React from 'react';
import Messages, { XAdkMessagesProps } from './Messages';
import Sender, { XAdkSenderCompoundProps } from './Sender';

/**
 * XAdkProvider.Chatbot - 完整的聊天界面组件
 *
 * 组合了 Messages + Sender,提供开箱即用的完整聊天界面
 *
 * @example
 * ```tsx
 * <XAdkProvider url="..." token="...">
 *   <XAdkProvider.Chatbot
 *     messagesProps={{ showFnCallDetail: true }}
 *     senderProps={{ allowUpload: true }}
 *   />
 * </XAdkProvider>
 * ```
 */
export interface XAdkChatbotCompoundProps {
  /** Messages 组件的属性 */
  messagesProps?: XAdkMessagesProps;
  /** Sender 组件的属性 */
  senderProps?: XAdkSenderCompoundProps;
  /** 容器样式 */
  style?: React.CSSProperties;
  /** 容器类名 */
  className?: string;
}

const Chatbot: React.FC<XAdkChatbotCompoundProps> = ({
  messagesProps,
  senderProps,
  style,
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        ...style,
      }}
    >
      {/* 消息列表区域 */}
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <Messages {...messagesProps} />
      </div>

      {/* 输入框区域 */}
      <Sender {...senderProps} />
    </div>
  );
};

Chatbot.displayName = 'XAdkProvider.Chatbot';

export default Chatbot;
